function berechneCpw() {
    let preis = document.getElementById('preis').value * 100; // Umwandlung in Cent
    let jahre = document.getElementById('jahre').value;
    let haeufigkeitProWoche = document.getElementById('haeufigkeitProWoche').value;
    const wochenProJahr = 52;
    const gesamtTraege = jahre * haeufigkeitProWoche * wochenProJahr;
    const cpw = preis / gesamtTraege;
    document.getElementById('ergebnis').innerHTML = `Cost Per Wear: ${cpw.toFixed(2)} Cent pro Tragen`;
}
